import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getMetrics,
  getTransactionMetrics,
} from "../../actions/metrics.action";
// import Header from "../../components/header/NavHeader";
// import { userTypes } from "../../utils/helpers/constants";
import { fetchEvents } from "../../actions/event.action";
import { fetchCommunities } from "../../actions/community.action";
import { fetchPeopleYouMayKnow } from "../../actions/student.action";
import { fetchAnnouncements } from "../../actions/announcement.action";
import Body from "./Body";

export default function Home() {
  const dispatch = useDispatch();
  const { profile } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  const { metrics } = useSelector(({ metricsReducer }) => ({
    metrics: metricsReducer,
  }));

  const {
    event: { events, eventListLoading },
  } = useSelector(({ eventReducer }) => ({
    event: eventReducer,
  }));

  const {
    community: { communities, communityLoading },
  } = useSelector(({ communityReducer }) => ({
    community: communityReducer,
  }));

  const {
    announcement: { announcements, announcementLoading },
  } = useSelector(({ announcementReducer }) => ({
    announcement: announcementReducer,
  }));

  const {
    student: { people, peopleLoading },
  } = useSelector(({ studentReducer }) => ({
    student: studentReducer,
  }));

  useEffect(() => {
    dispatch(getMetrics());
    dispatch(getTransactionMetrics());
  }, []);

  useEffect(() => {
    const pageAble = { page: 0, size: 6 };
    dispatch(fetchEvents(pageAble));
    dispatch(fetchCommunities(pageAble));
    dispatch(fetchAnnouncements(pageAble));
    dispatch(fetchPeopleYouMayKnow({ page: 0, size: 9 }));
  }, []);

  return (
    <Body
      profile={profile}
      systemMetrics={metrics.systemMetrics}
      transactionMetrics={metrics.transactionMetrics}
      announcements={announcements}
      announcementLoading={announcementLoading}
      communities={communities}
      communityLoading={communityLoading}
      events={events}
      eventListLoading={eventListLoading}
      people={people}
      peopleLoading={peopleLoading}
    />
  );
}
